<template>
  <div>
    <nav-title :title="'Clinicians Report'" :color="false" />
    <article class="container d-flex flex-column">
      <table v-if="childrensClinicians.length" class="table">
        <thead class="thead-dark table-clinician">
          <tr>
            <th scope="col" v-for="header in header" :key="header.value">{{ header }}</th>
          </tr>
        </thead>
        <tbody class="font-weight-light">
          <tr v-for="(row, index) in childrensClinicians" :key="index">
            <td v-for="(accessor, index) in accessors" :key="index">
              <div class="pointer" v-if="accessor === 'emails'">
                <span
                  title="View and edit emails"
                  @click="showEditModal(row)"
                  class="material-icons"
                >
                  visibility
                </span>
              </div>
              <div
                class="pointer"
                @click="handleDeleteCliniciansReport(row.id)"
                v-else-if="accessor === 'actions'"
              >
                <span title="Delete Clinician" class="material-icons">delete_outline</span>
              </div>
              <clinician-report-button-copy
                @updateClinicianReport="updateClinicianReport"
                :clinician="row"
                :selectedCopy="row['parent']"
                v-else-if="accessor === 'parent'"
              />
              <span v-else>{{ row['child']['name'] }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        <empty-module
          class="empty-module"
          title="Oops, so you haven't created any clinicians report, you can create it with the button below..."
          :icon="'people'"
        />
      </div>
      <section class="py-2">
        <b-button variant="primary" @click="$refs.scm.openModal()">Add Clinician</b-button>
      </section>
      <clinician-report-modal ref="scm" @onShareReport="handleSaveReport" />
      <clinician-report-info
        ref="cri"
        @updateClinicianReport="updateClinicianReport"
        :clinician="infoClinician"
      />
    </article>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import ClinicianReportModal from '@/components/general/modal/ClinicianReportModal';
import navTitle from '@/components/general/navTitle.vue';
import ClinicianReportButtonCopy from '@/components/general/modal/ClinicianReportModal/ClinicianReportButtonCopy.vue';
import ClinicianReportInfo from '@/components/general/modal/ClinicianReportModal/ClinicianReportInfo';
import mixinNotificationToast from '@/mixins/notificationToast.mixin.js';
import EmptyModule from '@/components/general/emptyModule.vue';
import store from '@/store';
export default {
  components: {
    navTitle,
    ClinicianReportModal,
    ClinicianReportInfo,
    ClinicianReportButtonCopy,
    EmptyModule,
  },
  mixins: [mixinNotificationToast],
  data() {
    return {
      emails: [],
      enableCopy: true,
      userId: '',
      header: ['Child', 'Emails', 'Copy', 'Actions'],
      accessors: ['name', 'emails', 'parent', 'actions'],
      infoClinician: {},
    };
  },
  methods: {
    ...mapActions('parent', [
      'shareReport',
      'deleteParentCliniciansReport',
      'parentGetCliniciansReport',
      'setParentCliniciansReport',
    ]),
    ...mapMutations('parent', ['setChildsCliniciansReport']),
    showEditModal(value) {
      this.infoClinician = JSON.parse(JSON.stringify(value));
      this.modalViewEmails = true;
      this.$refs.cri.openModal();
    },
    async handleDeleteCliniciansReport(id) {
      try {
        const clinicians = this.childrensClinicians.filter((clinician) => clinician.id !== id);
        this.setChildsCliniciansReport(clinicians);
        await this.deleteParentCliniciansReport(id);
        this.notificationToast({
          message: 'The clinicians have been successfully removed.',
          variant: 'success',
          title: 'Clinicians report',
        });
        this.$refs.scm.closeModal();
      } catch (error) {
        this.notificationToast({ message: error, variant: 'danger', title: 'Settings' });
      }
    },
    async handleSaveReport(data) {
      try {
        const newClinician = await this.shareReport({ data, parentId: this.userId });
        const clinicians = [...this.childsCliniciansReport, newClinician];
        this.setChildsCliniciansReport(clinicians);
        this.$refs.scm.closeModal();
        this.notificationToast({
          message: 'The clinician report will be created and shared at the beginning of each week.',
          variant: 'success',
          title: 'Settings',
        });
      } catch (error) {
        this.notificationToast({ message: error, variant: 'danger', title: 'Settings' });
      }
    },
    async updateClinicianReport(data) {
      try {
        const payload = {
          id: data.id,
          emails: data.emails,
          copy_to: data.parents,
          parents: this.userId,
        };

        if (!data.emails.length) {
          await this.handleDeleteCliniciansReport(data.id);
          return;
        }

        const updates = this.childrensClinicians.map((clinician) => {
          if (clinician.id === data.id) {
            return data;
          }
          return clinician;
        });
        this.setChildsCliniciansReport(updates);
        this.setParentCliniciansReport(payload);
        this.notificationToast({
          message: 'The clinician report will be updated and shared at the beginning of each week.',
          variant: 'success',
          title: 'Clinician report',
        });
      } catch (error) {
        this.notificationToast({
          message: 'Unable to update, please try again.',
          variant: 'danger',
          title: 'Clinician report',
        });
      }
    },
  },
  mounted() {
    this.userId = store.getters['user/getUserId'];
  },
  computed: {
    ...mapGetters('parent', ['getChildrenData']),
    ...mapState('parent', ['childsCliniciansReport']),
    ...mapGetters('parent', ['getChildsCliniciansReport']),
    childrensClinicians() {
      return this.childsCliniciansReport.map((child) => {
        const childJSON = JSON.parse(JSON.stringify(child));
        const isParent = Array.isArray(childJSON.parents)
          ? childJSON.parents.includes(Number(this.userId))
          : childJSON.parents;
        return {
          id: child.id,
          child: child.child,
          emails: child.emails,
          parents: isParent,
        };
      });
    },
  },
  async beforeMount() {
    let userId = store.getters['user/getUserId'];
    await store.dispatch('parent/parentGetCliniciansReport', userId);
  },
};
</script>
<style lang="scss" scoped>
.table-clinician {
  background-color: var(color-main);
}
</style>
